module.exports = __webpack_public_path__ + "prod/1.42.2/img/batch_bg.596878dc.png";